import { CatalystInsightFilterRequest } from '@api';
import { useQuery } from '@tanstack/react-query';
import {
  getCatalystInsightDetails,
  getCatalystInsightList,
} from '@terminal/services/insights/catalyst-insights-service';
import { getCatalystInsightListFromKg } from '@terminal/services/insights/kg-insights-service';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';

export const QUERY_KEY_CATALYST_INSIGHT = 'QUERY_KEY_CATALYST_INSIGHT';

export const useCatalystInsightsList = (
  payload: CatalystInsightFilterRequest,
  isEnabled = true
) => {
  const canShowCompanyCatalysts = !useSubscription(state =>
    state.isBasicOrLightUser()
  );
  const isCatalystGenerationEnabled = useFlags(state =>
    state.getFeatureFlagState('catalyst_generation')
  );

  return useQuery({
    queryKey: [
      QUERY_KEY_CATALYST_INSIGHT,
      payload,
      isCatalystGenerationEnabled,
    ],
    queryFn: ({ signal }) =>
      isCatalystGenerationEnabled
        ? getCatalystInsightListFromKg(payload, signal)
        : getCatalystInsightList(payload),
    select: data =>
      data.filter(
        insight => canShowCompanyCatalysts || insight.category !== 'company'
      ),
    staleTime: 0,
    gcTime: 0,
    enabled: isEnabled,
  });
};

export const QUERY_KEY_CATALYST_INSIGHT_DETAILS =
  'QUERY_KEY_CATALYST_INSIGHT_DETAILS';

export const useCatalystInsightDetails = (
  insightId: string,
  isEnabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEY_CATALYST_INSIGHT_DETAILS, insightId],
    queryFn: () => getCatalystInsightDetails(insightId),
    staleTime: 0,
    gcTime: 0,
    enabled: isEnabled,
  });
};
